import { useCallback } from 'react';

import { useTransactionStore } from '@/store/transaction';

import type { ChainAddress } from '@/utils/models';

import { showTradeToast } from './components/TransactionToast';
import { useCheckout } from './useCheckout';

/** Resets the rewrite checkout and hands an unfinished transaction to its toast. */
export function useDismissStatusScreen() {
  const [, dispatchCheckout] = useCheckout();

  return useCallback(() => {
    dispatchCheckout({ type: 'reset' });

    const transactionState = useTransactionStore.getState();
    const currentTransaction = transactionState.currentTransaction;
    if (!currentTransaction) return;

    const { tx, isSuccessful, address, chainId } = currentTransaction;
    if (!tx.hash) return;

    let crossChainTerminal = false;
    if (tx.transactionType === 'cross-chain') {
      const liveTransaction = transactionState.transactions[address]?.[chainId]?.find(
        (transaction) => transaction.hash === tx.hash,
      );
      crossChainTerminal =
        liveTransaction?.transactionType === 'cross-chain' &&
        Boolean(liveTransaction.destinationTxHash || liveTransaction.failureContext);
    }

    if (isSuccessful || crossChainTerminal) return;

    showTradeToast({
      walletAddress: address as ChainAddress,
      hash: tx.hash,
      chainId,
    });
  }, [dispatchCheckout]);
}
